module.exports = __webpack_public_path__ + "img/gp.c504bc79.svg";